package features.overtime.handlers

import AppState
import Router
import features.overtime.data.OvertimeRepository
import features.notifications.data.NotificationRepository
import kotlinx.browser.window

// Overtime Request Handlers
fun approveOvertimeRequest(teamId: String, requestId: String) {
    console.log("✅ Approving overtime request: $requestId for team: $teamId")
    
    val reviewerId = AppState.currentUser?.id
    val reviewerName = AppState.currentUser?.name
    if (reviewerId == null) {
        window.alert("User not authenticated")
        return
    }
    
    // Show loading state
    val confirmed = window.confirm("Approve this overtime request?")
    if (!confirmed) return
    
    // First, get the overtime request to find the requester
    OvertimeRepository.getOvertimeRequestById(teamId, requestId)
        .then { request ->
            if (request == null) {
                window.alert("Overtime request not found")
                return@then
            }
            
            // Approve the request
            OvertimeRepository.approveRequest(teamId, requestId, reviewerId)
                .then {
                    console.log("✅ Overtime request approved successfully")
                    
                    // Create notification for requester
                    val notificationTitle = "Overtime Request Approved ✅"
                    val notificationMessage = "Your overtime request for ${request.date} (${request.hours}) has been approved by ${reviewerName ?: "admin"}."
                    
                    NotificationRepository.createNotification(
                        userId = request.userId,
                        type = "overtime_approved",
                        title = notificationTitle,
                        message = notificationMessage,
                        relatedId = requestId
                    ).then {
                        console.log("✅ Notification sent to requester")
                        window.alert("Overtime request approved!")
                        Router.render()
                    }.catch { error ->
                        console.error("❌ Failed to send notification:", error)
                        window.alert("Overtime request approved, but failed to send notification.")
                        Router.render()
                    }
                }
                .catch { error ->
                    console.error("❌ Failed to approve overtime request:", error)
                    window.alert("Failed to approve request. Please try again.")
                }
        }
        .catch { error ->
            console.error("❌ Failed to get overtime request:", error)
            window.alert("Failed to load request details. Please try again.")
        }
}

fun rejectOvertimeRequest(teamId: String, requestId: String) {
    console.log("❌ Rejecting overtime request: $requestId for team: $teamId")
    
    val reviewerId = AppState.currentUser?.id
    val reviewerName = AppState.currentUser?.name
    if (reviewerId == null) {
        window.alert("User not authenticated")
        return
    }
    
    // Show confirmation
    val confirmed = window.confirm("Reject this overtime request?")
    if (!confirmed) return
    
    // First, get the overtime request to find the requester
    OvertimeRepository.getOvertimeRequestById(teamId, requestId)
        .then { request ->
            if (request == null) {
                window.alert("Overtime request not found")
                return@then
            }
            
            // Reject the request
            OvertimeRepository.rejectRequest(teamId, requestId, reviewerId)
                .then {
                    console.log("✅ Overtime request rejected successfully")
                    
                    // Create notification for requester
                    val notificationTitle = "Overtime Request Rejected ❌"
                    val notificationMessage = "Your overtime request for ${request.date} (${request.hours}) has been rejected by ${reviewerName ?: "admin"}."
                    
                    NotificationRepository.createNotification(
                        userId = request.userId,
                        type = "overtime_rejected",
                        title = notificationTitle,
                        message = notificationMessage,
                        relatedId = requestId
                    ).then {
                        console.log("✅ Notification sent to requester")
                        window.alert("Overtime request rejected!")
                        Router.render()
                    }.catch { error ->
                        console.error("❌ Failed to send notification:", error)
                        window.alert("Overtime request rejected, but failed to send notification.")
                        Router.render()
                    }
                }
                .catch { error ->
                    console.error("❌ Failed to reject overtime request:", error)
                    window.alert("Failed to reject request. Please try again.")
                }
        }
        .catch { error ->
            console.error("❌ Failed to get overtime request:", error)
            window.alert("Failed to load request details. Please try again.")
        }
}
